export default __webpack_public_path__ + "static/media/Shower.39dd6602.png";